
import { getServerInfo, getStatus } from '@/app/api';
import { getUserInfo } from '@/app/user-info';
import { useConnectionStore } from '@/stores/connection';
import { useSettingsStore } from '@/stores/settings';
import { useUserStore } from '@/stores/user';
import { Options, Vue } from 'vue-class-component';
import ticker from '@/app/ticker';

@Options({
  components: {
  },
})
export default class DataControl extends Vue {
  public connection = useConnectionStore();
  public settings = useSettingsStore();
  public user = useUserStore();

  public debug = false;

  mounted() {
    getServerInfo()
      .then(r => { this.connection.serverInfo = r; })
      .catch(() => { this.connection.failedGettingServerInfo = true; });

    // TODO: We might want to get info again if connection broke
    getUserInfo()
      .then(r => { this.user.info = r; })
      .catch(() => { this.user.failedGettingInfo = true; });

    ticker.onTick(this.getStatus);

    this.setPolling();

    this.settings.$subscribe(() => {
      this.setPolling();
    });
  }

  private setPolling(): void {
    ticker.setInterval(this.settings.pingInterval);
  }

  private getStatus() {
    getStatus()
      .then(status => {
        const statuses = [...this.connection.allStatuses].reverse();

        const now = (new Date()).getTime();

        let currentStatus;
        while (
          (currentStatus = statuses[statuses.length - 1]) &&
          (now - currentStatus.createdAt > this.settings.expiryDurationMinutes * 60 * 1000)
        ) {
          statuses.pop();
        }

        this.connection.allStatuses = [...statuses.reverse(), status];
      });
  }
}
